import * as _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';

import PlusIcon from '@material-ui/icons/PlaylistAdd';
import Typography from 'material-ui/Typography';

import HDrawer from '../../../common/HDrawer';
import ChipDrop from '../../../common/component/ChipDrop';
import PrimaryButton from '../../../common/component/PrimaryButton';
import SecondaryButton from '../../../common/component/SecondaryButton';

import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

export class SchemeCreateDrawerClass extends React.Component {
    state = {
        selectedTags: []
    };

    clearState = () => {
        this.setState({ selectedTags: [] });
    };

    createMarkup = v => {
        if (typeof v === 'object') {
            return { __html: v.abr };
        }
        return { __html: v };
    };

    handleSave = () => {
        const tagsIds = _.pluck(this.state.selectedTags, 'id');
        if (tagsIds.length === 0) {
            return this.setState({
                dropError: true
            });
        }
        const abr = this.props.abr;
        DesignerState.saveCustomScheme(this.props.exercise, abr, tagsIds);
        this.clearState();
    };

    handleClose = () => {
        const isOpen = false;
        DesignerState.toggleSchemeModal(this.props.exercise, isOpen);
        this.clearState();
    };

    handleChange = selectedTags => {
        this.setState({ selectedTags, dropError: false });
    };

    handleNewSchemeTag = async selectedOption => {
        this.setState({ dropError: false });
        const title = selectedOption.title;
        const newTag = await DesignerState.createTrainingEffectTag(title);
        const selectedTags = [...this.state.selectedTags, newTag];
        this.setState({ selectedTags });
    };

    convertedAbrHTML = () => {
        return (
            <div
                className="custom-overflow"
                dangerouslySetInnerHTML={this.createMarkup(this.props.abr)}
            />
        );
    };

    render() {
        Console.render('SchemeCreateDrawer');

        return (
            <HDrawer
                open={this.props.createSchemeDialog}
                onClose={this.handleClose}
                title="Save Prescription to Library"
                icon={<PlusIcon />}
            >
                <div className="create-dialog scheme-dialog layout-column">
                    <Typography>Title:</Typography>
                    {this.convertedAbrHTML()}
                    <ChipDrop
                        name="scheme-tags"
                        label="Category"
                        value={this.state.selectedTags}
                        multi={true}
                        options={this.props.schemeTags}
                        labelKey="title"
                        valueKey="id"
                        placeholder="Select category or type your own"
                        onChange={this.handleChange}
                        onNewOptionClick={this.handleNewSchemeTag}
                        hasError={this.state.dropError}
                        errorMessage="Select at least one category to save."
                    />
                    <div className="dialog-footer">
                        <SecondaryButton
                            onClick={this.handleClose}
                            disabled={this.state.disableButtons}
                        >
                            Cancel
                        </SecondaryButton>
                        <Typography
                            variant="title"
                            color="inherit"
                            className="flex"
                        />
                        <PrimaryButton onClick={this.handleSave}>
                            Save Prescription
                        </PrimaryButton>
                    </div>
                </div>
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        abr: state.calendar.uiTree.abr,
        createSchemeDialog: !!state.calendar.uiTree.createSchemeDialog,
        exercise: state.calendar.uiTree.exercise,
        schemeTags: state.calendar.uiTree.schemeTags,
        ...ownProps
    };
};

export default connect(mapStateToProps)(SchemeCreateDrawerClass);
